import { HOTEL_PAGE_SEARCH_REQUEST_TIMEOUT } from '@/js/common/Constants/hotelPageSearchConstants';
import requestService from '@/js/common/Domain/Service/request';
import getABTestValue from '@/js/common/Domain/Service/getABTestValue';

export default (tourCriteriaForTourRequest, callback) => requestService({
    cache: false,
    timeout: HOTEL_PAGE_SEARCH_REQUEST_TIMEOUT,
    url: `${window.appConfig.apiGatewayUrl}/frontend/railwaysTours`,
    data: {
        ...tourCriteriaForTourRequest,
        allToursPerHotel: 1,
        sections: ['countries', 'rooms', 'operators', 'firstPaymentDefinitions', 'routes', 'stations'],
        abTests: getABTestValue(),
    },
}, callback);